import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMilestone } from "../../contexts/MilestoneContext";
import BookingMilestone from "../BookingMilestone/BookingMilestone";
import "./ReservationThankYou.css";

const ReservationThankYou: React.FC = () => {
  const navigate = useNavigate();
  const userRole = useSelector((state: any) => state.auth.userRole) ?? "";
  const { setCurrentStep } = useMilestone();

  // Set step to 4 when reservation is completed
  useEffect(() => {
    setCurrentStep(4);
  }, [setCurrentStep]);

  const handleReturnToHome = () => {
    if (userRole === "B2BUser") {
      navigate("/b2b-property");
    } else {
      navigate("/rmc/dashboard");
    }
  };

  //   const handleContactUs = () => {
  //     navigate('/contact-us');
  //   };

  return (
    <>
      <BookingMilestone currentStep={4} />
      <div className="content has-nobreadcrumbs">
        <div className="content-body">
          <div className="reservation-thankyou-container">
            <div className="reservation-thankyou-modal">
              {/* Success Icon */}
              <div className="success-icon">
                <div className="checkmark-circle">
                  <i className="pi pi-check checkmark-icon"></i>
                </div>
              </div>

              {/* Thank You Title */}
              <h1 className="thankyou-title">Thank You!</h1>

              {/* Subtitle */}
              <h2 className="thankyou-subtitle">
                Your Reservation Request Has Been Received
              </h2>

              {/* Description */}
              <div className="thankyou-description">
                <p>
                  We've received your request. Our team is now reviewing your
                  details and will get back to you shortly to confirm your
                  booking and assist with any final arrangements.
                </p>
                <p>
                  You will receive a confirmation email with all the details
                  once your reservation is finalized. Please keep an eye on your
                  inbox.
                </p>
              </div>

              {/* Contact Link
          <div className="contact-link">
            <span>Have a question? </span>
            <button
              onClick={handleContactUs}
              className="contact-us-link"
            >
              Contact us.
            </button>
          </div> */}

              {/* Return to Home Button */}
              <button
                onClick={handleReturnToHome}
                className="return-home-button"
              >
                Return To Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReservationThankYou;
